import axios from 'axios'
import configs from '../configs'
import GenericDAO from "./../generic-dao";

const failed = new Promise(resolve => { resolve(false) })

const findAll = params => GenericDAO.find(`/medclub/titulo-receber/`, params);
const find = id => GenericDAO.find(`/medclub/titulo-receber-regra/${id}/`);
const findCredores = params => GenericDAO.find(`/medclub/titulo-receber/credores/`, params);
const findFaturas = params => GenericDAO.find(`/medclub/fatura/`, params);
const cancelarParcela = id => GenericDAO.find(`/medclub/titulo-receber/${id}/cancelar/`);
const editarParcela = (id, dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed
    return axios.patch(`${ configs.baseUrl }/medclub/titulo-receber/${id}/`, dataSend, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }`
        } })
        .then(response => response)
        .catch(configs.errorHandler)
};
const cancelarFatura = id => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed
    return axios.patch(`${ configs.baseUrl }/medclub/fatura/${id}/cancelar/`, {}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }`
        } })
        .then(response => response)
        .catch(configs.errorHandler)
};
const estornarFatura = id => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed
    return axios.patch(`${ configs.baseUrl }/medclub/fatura/${id}/estornar/`, {}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }`
        } })
        .then(response => response)
        .catch(configs.errorHandler)
};
const save = dataSend => GenericDAO.save(`/medclub/titulo-receber/`, dataSend, { ignorarEstabelecimento: true });
const baixaParcela = (cd_titulo, dataSend) => GenericDAO.save(`/medclub/titulo-receber/${cd_titulo}/liquidar/`, dataSend, { ignorarEstabelecimento: true });
const baixaFatura = (cd_fatura, dataSend) => GenericDAO.save(`/medclub/fatura/${ cd_fatura }/baixar/`, dataSend, { ignorarEstabelecimento: true });
const anexarComprovante = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = {
        cd_titulo: dataSend.cd_titulo,
        aq_comprovante_pagamento: dataSend.aq_comprovante_pagamento
    }

    if (dataSend.aq_comprovante_pagamento) {
        formData = new FormData()
        formData.append('aq_comprovante_pagamento', dataSend.aq_comprovante_pagamento)
        formData.append('cd_titulo', dataSend.cd_titulo)
    }
    return axios.patch(
        `${ configs.baseUrl }/medclub/titulo-receber/titulos-gerados/anexar-comprovante/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
    
}

export default {
    find,
    findAll,
    findCredores,
    findFaturas,
    save,
    cancelarParcela,
    baixaParcela,
    anexarComprovante,
    baixaFatura,
    cancelarFatura,
    estornarFatura,
    editarParcela
};
